'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('./../external/ismobilejs/esm/index.js');
var isMobile$1 = require('./../external/ismobilejs/esm/isMobile.js');

const isMobile = isMobile$1["default"](globalThis.navigator);

exports.isMobile = isMobile;
//# sourceMappingURL=isMobile.js.map
